import classNames from "classnames";
import { IconButton } from "@sprout/icon_button";
import CloseIcon from "@sprout/icons/close";

export interface TagProps {
  label: string;
  color?: string;
  size?: string;
  spacing?: boolean;
  className?: string;
  maxWidth?: string;
}

export const Tag = ({ label, color, size = "sm", spacing, className, maxWidth }: TagProps) => {
  const ellipsisClassName = classNames("ellipsis", maxWidth || "max-w-[142px]");

  return (
    <span
      className={classNames("tag-container", `tag-container--${size}`, className)}
      style={{ backgroundColor: color, marginLeft: spacing ? 8 : 0 }}
    >
      <span className={ellipsisClassName}>
        <span className={classNames("tag-text", `tag-text--${size}`)}>{label}</span>
      </span>
    </span>
  );
};

export interface DestroyableTagProps extends TagProps {
  onClick: () => void;
}

export const DestroyableTag = ({
  label,
  color,
  size = "sm",
  spacing,
  className,
  maxWidth,
  onClick,
}: DestroyableTagProps) => {
  const ellipsisClassName = classNames("ellipsis", maxWidth || "max-w-[142px]");

  return (
    <span
      className={classNames(
        "tag-container",
        "tag-container--destroyable",
        `tag-container--${size}`,
        className,
      )}
      style={{
        backgroundColor: color,
        marginLeft: spacing ? 8 : 0,
      }}
    >
      <span className={ellipsisClassName}>
        <span className={classNames("tag-text", `tag-text--${size}`)}>{label}</span>
      </span>
      <IconButton
        className={"tag-icon"}
        label="remove"
        icon={CloseIcon}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      />
    </span>
  );
};

export { default as useTagOverflow } from "./hooks/use_tag_overflow";
